module.exports = __webpack_public_path__ + "static/knittedwrap2-28771aaa64894d8babff07a2f9e0db15.jpeg";